import { ref } from "vue";
import { useToast } from "primevue/usetoast";

export function useJsonParser(requiredFields: string[] = []) {
  const toaster = useToast();
  const MAX_FILE_SIZE = 10_000_000; // 10 MB
  const jsonString = ref<string>();
  const error = ref<string>();

  async function processJson(
    event: Event | { target: HTMLInputElement & { files: File[] } }
  ): Promise<void> {
    if (event.target && "files" in event.target) {
      // Retrieve File Blob from button
      const file = event.target.files[0];

      // Check that file is loaded
      if (!file) {
        onParseFail("No file loaded");
        return;
      }
      try {
        // Parse JSON to check validity
        const jsonText = await file.text();
        const parsedJson = JSON.parse(jsonText);
        // Error if filesize is too large
        if (file.size > MAX_FILE_SIZE) {
          onParseFail("File is too large");
          return;
        }

        // Error if json does not contain passed in fields
        else if (
          !requiredFields.every(field => parsedJson[field] !== undefined)
        ) {
          onParseFail("Invalid fields in JSON");
          return;
        }

        jsonString.value = parsedJson;
      } catch (e) {
        // Fall back if JSON parsing fails
        onParseFail("File is not a valid JSON");
      }
    }
  }

  function onParseFail(message: string) {
    toaster.add({
      severity: "warn",
      summary: "Invalid",
      detail: message,
      life: 3000
    });
    error.value = message;
  }

  return { processJson, jsonString, error };
}
